export default "__VITE_ASSET__8abcc58b__"